import type React from 'react';

import { ProgressBar, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

export const VideoCountProgress: React.FC = () => {
	const { translate } = useI18n();

	return (
		<div className="bg-fill-information-weaker rounded-md p-4 text-center">
			<Text as="p" variant="body" size="small" fontWeight="bold" className="text-typography-strong mb-4">
				<Translate value="corgi.petition_actions.invite.goal_progress" />
			</Text>
			<ProgressBar ariaLabel={translate('corgi.petition_actions.invite.goal_progress')} percentage={40} size="large" />
		</div>
	);
};
